import { getHost } from './getHost'

export type ReportPdfLink = {
  title: string
  path: string
}

type ReportPdfFields = {
  report_pdf_url?: string | null
  report_pdf_advance_url?: string | null
  report_pdf_business_trip_url?: string | null
  report_pdf_order_url?: string | null
  report_pdf_driver_card_url?: string | null
  report_pdf_delivery_url?: string | null
}

const PDF_FIELDS: Array<{ key: keyof ReportPdfFields; title: string }> = [
  { key: 'report_pdf_url', title: 'Топливный отчёт' },
  { key: 'report_pdf_advance_url', title: 'Авансовый отчёт' },
  { key: 'report_pdf_business_trip_url', title: 'Командировочное' },
  { key: 'report_pdf_order_url', title: 'Приказ' },
  { key: 'report_pdf_driver_card_url', title: 'Карточка водителя' },
  { key: 'report_pdf_delivery_url', title: 'Путевой в PDF' },
]

export function getReportPdfLinks(report?: ReportPdfFields | null): ReportPdfLink[] {
  if (!report) return []
  return PDF_FIELDS.flatMap(({ key, title }) => {
    const path = report[key]
    return path ? [{ title, path }] : []
  })
}

export function reportPdfAbsoluteUrl(path: string): string {
  return `${getHost()}${path}`
}

export function hasReportPdfLinks(report?: ReportPdfFields | null): boolean {
  return getReportPdfLinks(report).length > 0
}
